import { createFileRoute } from '@tanstack/react-router'
import { RegisterSuratKeluarPanel } from '../../../../components/register-surat/RegisterSuratKeluarPanel'

export const Route = createFileRoute('/platform/desa/$desaId/register-surat')({
  component: () => {
    const { desaId } = Route.useParams()
    return <RegisterSuratKeluarPanel desaId={desaId} />
  },
})
